const UNSAFE_KEYS = new Set(['__proto__', 'prototype', 'constructor']);

/** Reconstructs imported data as inert own-data properties without unsafe keys. */
export function safeDataValue(value: unknown): unknown {
  if (value === null || typeof value !== 'object') return value;
  if (Array.isArray(value)) return value.map(safeDataValue);
  const result: Record<string, unknown> = {};
  for (const [key, nested] of Object.entries(value)) {
    if (!UNSAFE_KEYS.has(key)) result[key] = safeDataValue(nested);
  }
  return result;
}
